<div *ngIf="isWaiting" class="loading-spinner">
  <mat-progress-spinner [diameter]=25 class="spinner" mode="indeterminate"></mat-progress-spinner>
</div>

<div class="row-between">
  <h1>Team Roles Management - Standard IPT</h1>
  <div>

    <button type="button" mat-button class="btnNeutral"
            [disabled]="isExportDisabled()"
            (click)="onExportClicked()"
    >
      Export to XLSX
    </button>

    <button type="button" mat-button class="btnNegative"
            [disabled]="!isSaveAndResetDisabled()"
            (click)="onResetClicked()"
    >Reset</button>

    <button type="button" mat-button class="btnPositive"
            [disabled]="!isSaveAndResetDisabled()"
            (click)="onSaveClicked()"
    >Save</button>

  </div>
</div>

<form *ngIf="formGroup"
      [formGroup]="formGroup"
      class="row-left">

  <digires-list-input [formGroup]="formGroup"
                      formCtrlName="technology"
                      placeholder="Technology"
                      [items]="allTechnologies"
                      [itemToLabel]="getTechnologyLabel"
                      tooltip="Select the technology to edit"
  ></digires-list-input>

  <digires-country-input [formGroup]="formGroup"
                         formCtrlName="country"
                         placeholder="Country"
                         tooltip="Select the country to edit"
  ></digires-country-input>

  <digires-list-input [formGroup]="formGroup"
                      formCtrlName="projectPhase"
                      placeholder="Phase"
                      [items]="allProjectPhases"
                      [itemToLabel]="getProjectPhaseLabel"
                      tooltip="Select the Phase to edit"
  ></digires-list-input>

</form>

<div *ngIf="iptEntries" class="ipt-body">
  <div *ngFor="let entry of iptEntries">

    <h2>{{iptPhaseToLabel[entry.ipt.phase]}}</h2>
    <digires-team-member-list [iptPhase]="entry.ipt.phase"
                              [entries]="entry.memberEntries"
                              [allUsers]="allUsers"
                              [allRoles]="allRoles"
                              [showCheckbox]="false"
                              [canAdd]="true"
                              [readOnly]="null"
    ></digires-team-member-list>

  </div>
</div>
